export default "__VITE_ASSET__DCZaV5Ee__"